import useBrowserMode from "../shared/hooks/useBrowserMode"
export const changeRef = (redireccion: string) => {
    const { window } = useBrowserMode()
    const prefixClean = process.env.GATSBY_PATHPREFIX!.split("/")[1] 
    let hostname = `${process.env.GATSBY_PATHPREFIX}/`

    try {
        hostname = window?.location?.hostname === "localhost" ? "/" : `${process.env.GATSBY_PATHPREFIX}/`
    } catch (error) {
        console.error(error)
    }
    redireccion = redireccion ?? "/"
    if (
        redireccion?.includes("https") ||
        redireccion?.includes("http") ||
        redireccion?.includes("www")
    ) {
        return redireccion
    } else {
        const paths = redireccion?.split("/")
        if (paths && (paths[0].includes(prefixClean) || paths[0] === "")) {
            paths.shift()
        }
        console.log("changeRef", redireccion, paths)
        return paths ? `${hostname}${paths.join("/")}` : "/"
    }
}